/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/views_by_variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpVarToView {
  constructor() {
    this.v_to_v = {};
  }

  buildVarToView(v2V) {
    this.v_to_v = v2V;
  }

  getViewByVar(id) {
    return this.v_to_v[id];
  }
}


export default LpVarToView;



// WEBPACK FOOTER //
// ./src/app/indexes/views_by_variables.js